import styled from "styled-components";
import { Container, Row } from "reactstrap";

export const BootstrapContainer = styled(Container)`
  max-width: 700px;
`;

export const BootstrapRow = styled(Row)`
  height: 5rem;
`;

export const BootstrapBodyRow = styled(Row)`
  padding: 25px;
`;
